export default {
	"baiduPointMap": {
		"handleTips": "กรุณาลากจุดพิกัดของที่อยู่"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/components/map/map.js